import React, { Component, Fragment } from "react";
import mapboxgl from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

import classes from "./BoundingBoxMap.module.scss";
import SectionTitle from "./../../../general/SectionTitle/SectionTitle";

class BoundingBoxMap extends Component {
  getPoints = (draw) => {
    let data = draw.getAll();
    let updatePolygons = [];
    let newPolygons = [];
    for (let feature of data.features) {
      // if polygon feature id has polygon in it, it's an existing polygon that needs updating
      if (feature.id.includes("polygon")) {
        updatePolygons.push({
          polygonId: feature.id.split("-")[1],
          points: feature.geometry.coordinates[0]
        });
      } else {
        // otherwise, it's a new polygon that needs to be added to db
        newPolygons.push(feature.geometry.coordinates[0]);
      }
    }
    this.props.update(newPolygons, updatePolygons);
  };

  delete = (draw, e) => {
    // get points of added/updated polygons to prevent adding new polygons that were deleted before existing in the db
    this.getPoints(draw);
    // get deleted polygons
    let deletePolygons = [];
    for (let feature of e.features) {
      // polygon needs to be deleted from db only if it's id is a polygon with an id
      if (feature.id.includes("polygon")) {
        deletePolygons.push(feature.id.split("-")[1]);
      }
    }
    this.props.delete(deletePolygons);
  };

  drawPolygons = (draw) => {
    // load any existing polygons
    if (this.props.polygons) {
      // loop through polygons and draw them to mapbox
      for (let polygon of this.props.polygons) {
        draw.add({
          id: `polygon-${polygon.bounding_box_id}`,
          type: "Feature",
          properties: {},
          geometry: {
            type: "Polygon",
            coordinates: [polygon.points]
          }
        });
      }
    }
  };

  componentDidMount() {
    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
    // intial map setup
    const map = new mapboxgl.Map({
      container: this.mapRef,
      style: "mapbox://styles/mapbox/light-v9",
      center: [-118.240194, 33.8644],
      zoom: 9,
      minZoom: 5,
      maxZoom: 15
    });

    let draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: true,
        trash: true
      }
    });
    map.addControl(draw, "top-right");

    map.on("draw.create", () => this.getPoints(draw));
    map.on("draw.delete", (e) => this.delete(draw, e));
    map.on("draw.update", () => this.getPoints(draw));

    map.on("load", () => this.drawPolygons(draw));

    const nav = new mapboxgl.NavigationControl();
    map.addControl(nav, "bottom-right");
  }

  render() {
    return (
      <Fragment>
        <div className={classes.mapContainer}>
          <div className={classes.title}>Bounding Box</div>
          <div className={classes.map} ref={(el) => (this.mapRef = el)} />
        </div>
      </Fragment>
    );
  }
}

export default BoundingBoxMap;
